exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#picWrapper .pic-error{width:100%;height:100%;position:relative;text-align:center}", ""]);

// exports
